import { BaseDataRow } from 'shared/components/DataRow/components/DataRow';

import { CellSkeleton } from './components/CellSkeleton';
import { TitleCellSkeletonWrapper } from './components/TitleCellSkeletonWrapper';

export const Skeleton = () => (
  <BaseDataRow sx={{ gridTemplateColumns: '1fr auto auto', columnGap: 1.5 }}>
    <TitleCellSkeletonWrapper>
      <CellSkeleton sx={{ width: 120, height: 12 }} />
      <CellSkeleton sx={{ width: 160, height: 16 }} />
      <CellSkeleton sx={{ width: 120, height: 12 }} />
    </TitleCellSkeletonWrapper>
    <CellSkeleton sx={{ width: 80, height: 12 }} />
    <CellSkeleton sx={{ width: 24, height: 24 }} />
  </BaseDataRow>
);
